import { fetcher } from '@commenda/utils';

export type BulkSubscribeToServiceRequestsParams = {
  serviceRequestIds: string[];
};

export type BulkSubscribeToServiceRequestsResponse = {
  subscribedThreadCount: number;
};

type BulkSubscribeToServiceRequestsResult = {
  success: boolean;
  data?: BulkSubscribeToServiceRequestsResponse;
  error?: string;
  statusCode?: number;
};

export async function bulkSubscribeToServiceRequests({
  serviceRequestIds,
}: BulkSubscribeToServiceRequestsParams): Promise<BulkSubscribeToServiceRequestsResult> {
  try {
    const response = await fetcher('chatRoom/subscription/bulk', {
      method: 'POST',
      body: { serviceRequestIds },
    });

    if (!response.ok) {
      const responseData = await response.json();
      return {
        success: false,
        error: responseData?.message || 'Failed to subscribe to threads',
        statusCode: response.status,
      };
    }

    const responseData: BulkSubscribeToServiceRequestsResponse =
      await response.json();
    return {
      success: true,
      data: responseData,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to subscribe to threads';
    return {
      success: false,
      error: errorMessage,
      statusCode: 500,
    };
  }
}
